// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon
module.exports.BiMale = function BiMale (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"circle","attr":{"cx":"12","cy":"4","r":"2"}},{"tag":"path","attr":{"d":"M15,7H9C8.447,7,8,7.447,8,8v7h2v7h2h2v-7h2V8C16,7.447,15.553,7,15,7z"}}]})(props);
};
